/**
 * @generated SignedSource<<e569e0f5ee7e7c979546644c364515dc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedItemTilesCarouselModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarousel_viewer">;
  readonly " $fragmentType": "HpSharedItemTilesCarouselModule_viewer";
};
export type HpSharedItemTilesCarouselModule_viewer$key = {
  readonly " $data"?: HpSharedItemTilesCarouselModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedItemTilesCarouselModule_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchFavorites",
          "variableName": "fetchFavorites"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "07c4f6cee9351e0d48f1357f569fdfcf";

export default node;
